import script from "./SankeyChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SankeyChart.vue?vue&type=script&setup=true&lang=js"

import "./SankeyChart.vue?vue&type=style&index=0&id=6089f9ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6089f9ea"]])

export default __exports__